import { Record, Map } from 'immutable';
import { pagingActions, fetchListActions, closeMessageActions, actionTypes } from './published.actions';
import { modifyMessageActions } from '../modify-message';
import * as api from '../../api';
import { authActions } from '../../auth';
import { pagingDataUtilities } from '../../common';

export const PendingClosedState = Record({
  showModal: false,
  messageId: null,
});

export const PublishedMessagesState = Record({
  pagingData: pagingDataUtilities.PagingState({}),
  listState: api.ApiCallState({}),
  closingMessages : Map({}),
  pendingClosed: PendingClosedState({}),
});


export const publishedReducer = (initialState = new PublishedMessagesState(), action) => {

    var state = initialState.set('pagingData',
      pagingDataUtilities.pagingReducer(initialState.get('pagingData'), action, pagingActions));

    const invalidateActions = pagingActions.allTypes
      .concat([
        authActions.actionTypes.CREATE_ETO_SESSION_SUCCESS,
        closeMessageActions.success,
        modifyMessageActions.addMessageActions.success,
        modifyMessageActions.updateMessageActions.success
      ]);
    state = state.set('listState',
      api.apiCallReducer(state.get('listState'), action, fetchListActions, invalidateActions));

    state = state.setIn(['closingMessages', action.id],
      api.apiCallReducer(state.getIn(['closingMessages', action.id]), action, closeMessageActions));

    switch(action.type) {
      case actionTypes.CLOSE_MESSAGE_SHOW_MODAL:
        state = state.setIn(['pendingClosed', 'showModal'], true)
                     .setIn(['pendingClosed', 'messageId'], action.messageId);
        break;
      case actionTypes.CLOSE_MESSAGE_CLOSE_MODAL:
        state = state.setIn(['pendingClosed', 'showModal'], false);
        break;
      default:
    }
    return state;
  }
